import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SubPortfolioAnalyticsComponent } from './sub-portfolio-analytics.component';


const routes: Routes = [
  {
    path: '',
    component: SubPortfolioAnalyticsComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SubPortfolioAnalyticsRoutingModule { }
